<template>
  <div :class="['popin', 'popin-question']">
    <div :class="['popin-container', showRecto ? 'recto' : '']">
      <div class="front">
        <img :src="`http://transfertsdepekin.fr/assets/questions/${params.characterImg}`" :alt="params.character">

        <div class="popin-question">
          <p class="popin-question__name">{{ params.character }}</p>

          <p class="popin-question__question" v-html="params.question"></p>

          <ul v-if="params.type === 'question'">
            <li v-for="(answer, i) in params.answers" @click="choiceAnswer" :data-index="i" v-html="answer.answer"></li>
          </ul>

          <button class="popin-question__chance btn" v-if="params.type === 'chance'" @click="chanceResult">Chance</button>
        </div>
      </div>

      <div class="back">
        <img :src="`http://transfertsdepekin.fr/assets/questions/${params.characterImg}`" :alt="params.character">

        <div class="popin-question">
          <p class="popin-question__name">{{ params.character }}</p>
          <p class="popin-question__award" v-if="textResult" v-html="textResult"></p>
          <p class="popin-question__result" v-if="result" v-html="result.text"></p>
          <a class="popin-question__continue btn" @click="setPopinState">
            Continuer l'aventure

            <img v-if="params.type === 'chance'" src="http://transfertsdepekin.fr/assets/places/chance1.png" alt="Fortune cookie" class="popin-question__cookie">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookie from 'js-cookie';

  export default {
    name: 'popin',
    props: [
      'params',
    ],
    data() {
      return {
        showRecto: false,
        result: null,
        newScore: 0,
        textResult: null,
        random: null,
        isEnd: false,
        loosePopin: false,
        nothing: false,
        looseGame: false,
      };
    },
    created() {
      let random = null;

      if (this.params.type === 'chance') {
        random = Math.random() * 2;
        this.random = random;
        this.chanceResult();
      }
    },
    methods: {
      setPopinState() {
        const self = this;

        this.$store.commit('setShowPopin', false);

        if (this.isEnd) {
          setTimeout(() => {
            self.$router.push('/the-end');
          }, 800);
        } else {
          if (!this.nothing) {
            setTimeout(() => {
              self.$store.commit('setAnimMoney', true);
            }, 400);

            setTimeout(() => {
              self.$store.commit('setActualQuestion', self.key);

              self.$store.commit('setQuestionCycle', {
                index: self.cycle,
                data: self.$store.getters.getQuestionsData[self.key],
              });

              self.$store.commit('setQuestionCycle', {
                index: self.cycle - 1,
                data: null,
              });

              self.$store.commit('setMoney', self.newScore);

              Cookie.set('question', { actual: self.key, index: self.cycle, data: self.$store.getters.getQuestionsData[self.key] }, 7);
            }, 1100);

            setTimeout(() => {
              self.$store.commit('setAnimMoney', false);
            }, 2000);
          } else {
            setTimeout(() => {
              self.$store.commit('setActualQuestion', self.key);

              self.$store.commit('setQuestionCycle', {
                index: self.cycle,
                data: self.$store.getters.getQuestionsData[self.key],
              });

              self.$store.commit('setQuestionCycle', {
                index: self.cycle - 1,
                data: null,
              });

              Cookie.set('question', { actual: self.key, index: self.cycle, data: self.$store.getters.getQuestionsData[self.key] }, 7);
            }, 600);
          }
        }
      },
      choiceAnswer(e) {
        this.showRecto = true;
        this.result = this.params.answers[parseInt(e.target.getAttribute('data-index'), 10)];

        this.setMoney();

        if (window.innerWidth <= 650) {
          this.$el.scrollTop = 0;
        }
      },
      chanceResult() {
        this.showRecto = true;

        if (this.random > 1) {
          this.result = this.params.answers[0];
        } else {
          this.result = this.params.answers[1];
          this.loosePopin = true;
        }

        this.setMoney();
      },
      setMoney() {
        const win = this.result.win;
        const winNb = parseInt(win.replace('+', '').replace('-', ''), 10);

        let money = this.$store.getters.getMoney;

        const million = 'M€';

        this.nothing = false;

        if (win.indexOf('+') > -1) {
          this.$store.commit('setAnimMoneyReverse', false);
          money += winNb;
          this.textResult = `Vous avez gagné ${winNb} ${million}&nbsp;!`;
        } else if (win.indexOf('-') > -1) {
          this.$store.commit('setAnimMoneyReverse', true);
          money -= winNb;
          this.textResult = `Vous avez perdu ${winNb} ${million}&nbsp;!`;
          this.loosePopin = true;

          if (money <= 0) {
            this.looseGame = true;
          }
        } else {
          this.nothing = true;
          this.textResult = 'Vous n\'avez rien gagné...';
        }

        if (this.looseGame) {
          this.setNextQuestion('end');
          this.newScore = 0;
        } else {
          this.setNextQuestion(this.result.goTo);
          this.newScore = money;
        }

        Cookie.set('money', this.newScore, 7);
      },
      setNextQuestion(key) {
        if (key === 'end') {
          this.$store.commit('setEnd', true);
          this.isEnd = true;
        } else if (key === 'win') {
          this.$store.commit('setWin', true);
          this.$store.commit('setEnd', true);
          this.isEnd = true;
        } else {        
          let cycle = this.$store.getters.getCycle + 1;
          this.$store.commit('setCycle', cycle);

          if (cycle > 1) {
            cycle = 0;
          }

          this.cycle = cycle;
          this.key = key;
        }
      },
    },
  };
</script>

<style lang="scss">
  .popin-question {
    .popin-container {
      width: 769px;
      height: 540px;
      background: url('../assets/img/bg_question.png') no-repeat center center;
      background-size: cover;
      -webkit-perspective: 1000;
      -moz-perspective: 1000;
      -o-perspective: 1000;
      perspective: 1000;    
    }
  }

  .popin {
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($orange, .8);
    display: flex;
    align-items: center;
    justify-content: center;
    @include defaultTransition(.4);

    &.overlay--blue {
      background: rgba($blue, .8);
    }

    @include mobile {
      display: block;
      bottom: inherit;
      height: 100%;
      background: $beige;
      border: 10px solid $orange;
 
      &.overlay--blue {
        background: $beige;
      }
    }

    .popin-container {
      position: relative;
      transform: translateZ(500px);
      transition: all 1s .3s ease;

      @include mobile {
        width: 100%;
        height: 100%;
        background: none;
      }

      &.recto {
        transform: rotateY(180deg) translateZ(-500px);

        @include mobile {
          transform: none;
        }

        .front {
          opacity: 0;
        }

        .back {
          opacity: 1;
          z-index: 3;
        }
      }
    }

    .front,
    .back {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      display: flex;
      align-items: center;

      @include mobile {
        display: block;
        bottom: inherit;
        overflow: scroll;
        height: 100%;
      }

      img {
        margin-right: 30px;
        max-width: 30%;
        flex-shrink: 0;

        @include mobile {
          max-width: 50%;
          display: block;
          margin: 0 auto 30px;
        }
      }
    }

    .popin-question__name {
      color: $blue;
      font-weight: 600;
      margin-bottom: 15px;
      @include fontSize(35);

      @include mobile {
        text-align: center;
        @include fontSize(25);
      }
    }

    .front {
      z-index: 2;
      padding: 130px 60px 70px 90px;
      transition: all .3s ease;

      @include mobile {
        padding: 30px 4%;
      }

      .popin-question__question {
        color: $blue;
        margin-bottom: 20px;
        @include fontSize(15);
      }

      ul li {
        background: $blue;
        border: 1px solid $blue;
        color: $white;
        cursor: pointer;
        padding: 8px;
        margin-bottom: 5px;
        @include fontSize(14);
        @include defaultTransition(.4);

        @include mobile {
          margin-bottom: 15px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          background: $white;
          color: $blue;
        }
      }
    }

    .back {
      padding: 130px 100px 70px 40px;
      opacity: 0;
      transform: rotateY(180deg);
      transition: all .3s 1.3s ease;

      @include mobile {
        transform: none;
        padding: 30px 4%;
        transition: all .3s ease;
      }

      .popin-question__cookie {
        position: absolute;
        top: 20px;
        right: -50px;
        margin-right: 0;
        width: 100px;

        @include mobile {
          display: none;
        }
      }
    }

    .popin-question__result {
      color: $blue;
      margin-bottom: 30px;
      @include fontSize(15);
    }

    .popin-question__award {
      color: $orange;
      font-style: italic;
      font-weight: 700;
      margin-bottom: 20px;
      @include fontSize(30);

      @include mobile {
        text-align: center;
        @include fontSize(21);
      }
    }

    .popin-question__chance {
      display: block;
      padding: 10px 30px;
      font-family: $main_font;
      cursor: pointer;
      width: 150px;
      margin: 50px auto 0;
      @include fontSize(23);
    }

    .popin-question__continue {
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// Popin.vue?5e355ce8